



































/* tslint:disable:no-console */
import Vue from 'vue';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import moment from 'moment';
import Verifier from '@/components/scanner/Verifier.vue';
import LuxtagMixin from '@/assets/ts/luxtagMixin';
import LuxtagApi from '@/api';
import { setInterval } from 'timers';

@Component({
  components: {
    Verifier,
  },
  filters: {
    filterDate(val: any) {
      return moment(val).format('ddd, DD MMM YYYY');
    }
  }
})
export default class Home extends Mixins(LuxtagMixin) {
  public verify: boolean = false;
  public refresh: boolean = false;
  public curEvent: any = {};
  public eventId: number = 0;

  @Watch('refresh')
  public async onRefreshChange(val: boolean) {
    if (val) {
      // if it close then
      // emit to parent component to change the prop
      // console.log('refresh: ', val);
      this.refresh = false;
      await this.getEvent(this.eventId);
    }
  }
  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      // access to component instance via `vm`
      vm.$store.commit('MUTATE_SHOW_NAVIGATION', true);
      vm.$store.commit('MUTATE_TITLE', 'Event Details');
      vm.$store.commit('MUTATE_HEADER_STYLE', true);
    });
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    this.$store.commit('MUTATE_SHOW_NAVIGATION', false);
    this.$store.commit('MUTATE_TITLE', '');
    this.$store.commit('MUTATE_HEADER_STYLE', false);
    next();
  }

  public created() {
    if (this.$route.params.eventId) {
      this.eventId = parseInt(this.$route.params.eventId);
      this.getEvent(this.$route.params.eventId);

      setInterval(() => {
        this.getEvent(this.$route.params.eventId);
      }, 5000);
    }
  }
  public async getEvent(id: any) {
    // console.log('getEvent: ', id);
    const response = await LuxtagApi.event.show(id);
    // console.log(response);
    if (response) {
      this.curEvent = response.data;
    }
  }

  get event() {
    // console.log('enter');
    return this.curEvent;
  }

  public navigate() {
    this.$router.push({ path: '/landing' });
  }
}
